<template>
  <!-- Duas linhas: busca + filtros ocupam a largura toda em cima (assim os chips
       não quebram para baixo do input por falta de espaço); contador de pendentes
       e "Ver histórico" ficam numa linha própria, logo acima da tabela. -->
  <div class="w-full flex flex-col gap-3">
    <HandoverFilters
      :model-value="handoverStore.filters"
      context="pending"
      @update:model-value="applyFilters"
    />

    <div class="flex items-center gap-2">
      <div
        v-if="totalPending > 0"
        class="flex items-center px-2 py-1 rounded border border-[#9e9eb7] bg-[#e2e2e9] text-sm text-[#16161d]"
      >
        {{ totalPending }} aprovações pendentes
      </div>
      <button
        class="ml-auto flex items-center gap-1 px-1 py-3 rounded text-sm font-bold text-[#2f7f91] hover:bg-gray-50"
        data-testid="handover-view-history-button"
        @click="$emit('viewHistory')"
      >
        <v-icon size="20" color="#2f7f91" :icon="mdiHistory" />
        Ver histórico
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { mdiHistory } from '@mdi/js'
import { useHandoverStore } from '@/pinia-store/useHandoverStore'
import HandoverFilters from './HandoverFilters.vue'
import type { HandoverFilterValues } from './handoverFilters.types'

defineEmits<{
  viewHistory: []
}>()

const handoverStore = useHandoverStore()
const { totalPending } = storeToRefs(handoverStore)

const applyFilters = (filters: HandoverFilterValues) => {
  handoverStore.setFilters(filters)
  handoverStore.fetchPendingApprovals(1)
}
</script>
